var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.isActive === true ? 'el-icon-s-fold' : 'el-icon-s-unfold',staticStyle:{"font-size":"30px"},on:{"click":_vm.toggleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }